/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ oci: NonNullable<unknown>, product: NonNullable<unknown>, available: NonNullable<unknown> }} Reservation_Cargo_OptionInputs */

const en_reservation_cargo_option = /** @type {(inputs: Reservation_Cargo_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.oci} - ${i?.product} (${i?.available} available now)`)
};

const es_reservation_cargo_option = /** @type {(inputs: Reservation_Cargo_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.oci} - ${i?.product} (${i?.available} disponibles ahora)`)
};

/**
* | output |
* | --- |
* | "{oci} - {product} ({available} available now)" |
*
* @param {Reservation_Cargo_OptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reservation_cargo_option = /** @type {((inputs: Reservation_Cargo_OptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reservation_Cargo_OptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reservation_cargo_option(inputs)
	return es_reservation_cargo_option(inputs)
});